import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

import closeX from '../../images/clear-field-icon_white.png';
import * as messages from '../../messages/ReportsMessages';

class ChannelCategoryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getStyles = event => ({
    minWidth: '120px',
    minHeight: '100px',
    height: 'auto',
    width: 'auto',
    border: '1px solid RGB(71, 100, 138)',
    position: 'absolute',
    left: `calc(${event.offsetX}px - 20% - 4rem - 30px)`,
    top: `calc(${event.offsetY}px - 5.5rem - 119px)`,
    display: this.props.visibility ? 'block' : 'none',
    backgroundColor: '#fff',
  });

  renderTable = () =>
    this.props.data.map(({ label, value }) => (
      <tr key={uuid()}>
        <td>{label}</td>
        <td>{value.pct.replace(/%/g, '')}</td>
        <td>{value.index}</td>
      </tr>
    ));

  render() {
    return (
      <div>
        <div
          className="quick-reports-dropdown general-stats-table"
          style={this.getStyles(this.props.event)}
        >
          <p>
            {this.props.title.name}
            <span
              onClick={() => this.props.hideTable()}
              role="button"
              tabIndex="0"
            >
              <img src={closeX} alt="close icon" />
            </span>
          </p>
          <div>
            <table>
              <tr>
                <th>{messages.WEBSITE}</th>
                <th>{messages.PERCENT}</th>
                <th>{messages.INDEX}</th>
              </tr>
              <tbody>
                {this.renderTable().length
                  ? this.renderTable()
                  : messages.TABLE_STILL_LOADING}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

ChannelCategoryTable.propTypes = {
  visibility: PropTypes.bool,
  event: PropTypes.shape({}),
  hideTable: PropTypes.func,
};

export default ChannelCategoryTable;
